import { render, staticRenderFns } from "./qrCall.vue?vue&type=template&id=cad7f4e8&scoped=true"
import script from "./qrCall.vue?vue&type=script&lang=js"
export * from "./qrCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad7f4e8",
  null
  
)

export default component.exports